import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5v10a1 1 0 0 0 1 1h10","key":"svg-0"}],["path",{"d":"M5 8h10a1 1 0 0 1 1 1v10","key":"svg-1"}]]

/**
 * IconCrop
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3JvcCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOCA1djEwYTEgMSAwIDAgMCAxIDFoMTAiIC8+CiAgPHBhdGggZD0iTTUgOGgxMGExIDEgMCAwIDEgMSAxdjEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/crop
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCrop = createReactComponent('outline', 'crop', 'Crop', __iconNode);

export default IconCrop;